import {CoreGameConfig} from '@gongxigames/framework/core';
import {SlotSettingsParameters} from '@gongxigames/framework/slot/configs/SlotSettings';
import {IAudioConfig} from '@gongxigames/framework/slot/types/IAudioConfig';

export type SlotGameConfig = CoreGameConfig & {
    gameName: string;
    gamePatch: string;
    RTP: number;
    mathHash: string;
    clientVersion?: string;
    maxMultiplier: string;
    isRubyCoinsGame?: boolean;
    freeSpins: boolean;
    clientSettings?: Partial<SlotSettingsParameters>;
    winProbability: string;
    detailedRTP?: Record<string, number>;

    // TODO: refactor
    audioConfig: IAudioConfig;
};
